import {
  CMP_ACCOUNT,
  CMP_LOCATIONS,
  PLS_ACCOUNT,
  UBER_LOCATIONS
} from './constants';
import { hasPatronAccount, hasPlsAccount } from './roles';

export const isLocationPls = location => {
  const locationId = typeof location === 'string' ? location : location?.id;
  return locationId === 'Miami';
};

export const isLocationCmp = location => {
  const locationId = typeof location === 'string' ? location : location?.id;
  return CMP_LOCATIONS.includes(locationId);
};

export const isLocationUber = location => {
  const locationId = typeof location === 'string' ? location : location?.id;
  return UBER_LOCATIONS.includes(locationId);
};

export const determineRequiredAccountType = (location, user) => {
  if (isLocationPls(location) && !hasPlsAccount(user)) {
    return PLS_ACCOUNT;
  } else if (!isLocationPls(location) && !hasPatronAccount(user)) {
    return CMP_ACCOUNT;
  }
  return null; // user has both types of account
};

export const isSwitchingAccountType = (currLocation, newLocation) => {
  const isCmpToPlsSwitch =
    isLocationCmp(currLocation) && isLocationPls(newLocation);
  const isPlsToCmpSwitch =
    isLocationPls(currLocation) && isLocationCmp(newLocation);
  return isCmpToPlsSwitch || isPlsToCmpSwitch;
};
